import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface TeamItem {
  /** 团队ID */
  team_id: number
  /** 团队名称 */
  name: string
  /** 父id */
  parent_team_id: number
  /** 终端总数 */
  count?: number
  /** 子分组 */
  children: TeamItem[]
  /** 1-在线，2-离线 */
  online: number
  /** 是否根节点 前端字段 */
  is_root?: boolean

  /** 为适配G6节点字段 */
  [key: string]: any
}

export interface TeamTreeRes {
  tree: TeamItem
}

@Injectable()
export class BranchOverviewService {
  constructor(private http: Http) {}

  getTeamTree(data = {}) {
    return this.http.post<TeamTreeRes>('/cascade/tree', data,).then(res => {
      res.tree = res.tree || {} as TeamItem
      res.tree = traverseTree(res.tree)
      return res
    })
  }
}

/** 适配器，接口数据至前端和G6 */
export function traverseTree(data: TeamItem) {
  const traverse = (node = {} as TeamItem) => {
    if (typeof node !== 'object' || node === null) return
    node.team_id = node.team_id === undefined ? undefined : Number(node.team_id)
    node.parent_team_id = Number(node.parent_team_id)
    node.is_root = node.team_id === data.team_id
    node.id = `node_${node.team_id}` // 必须提供string类型id字段名给G6，不然过度动画异常
    if (+node.online === 2) {
      node.name_icon = 'views/dashboard/cascade-center/branch-overview/_images/division-outline'
    } else {
      node.name_icon = node.is_root ? 'views/dashboard/cascade-center/branch-overview/_images/headquarters' : 'views/dashboard/cascade-center/branch-overview/_images/division'
    }
    node.children = node.children?.filter(v => v?.team_id !== undefined) || []
    if (Array.isArray(node.children) && node.children.length > 0) {
      node.children.forEach((child) => {
        traverse(child)
      })
    }
  }

  traverse(data)
  return data
}

/**
 * 判断 childId 是否是 parentId 本身或其子节点（含多级）
 * @param {Object} node 树结构根节点
 * @param {number} parentId 父节点 team_id
 * @param {number} childId 子节点 team_id
 * @returns {boolean}
 */
export function isSelfOrChild(node, parentId, childId): boolean {
  if (node.team_id === parentId) {
    if (childId === parentId) return true
    if (!node.children) return false
    return node.children.some(child =>
      child.team_id === childId || isSelfOrChild(child, child.team_id, childId)
    )
  }
  if (node.children) {
    return node.children.some(child => isSelfOrChild(child, parentId, childId))
  }
  return false
}
